/**
 * User: Keith
 * Author: Faris
 * Date: 7/13/2015
 * Time: 5:55 PM
 */

define('app/views/contact',['require','./page','text!../../../views/contact.html'],function(require) {

  var Page = require('./page');  
  var template = require('text!../../../views/contact.html');

  return Page.extend({
	 template: _.template(template),
	 
	// Event listeners
    events: {
      'click #formSubmit' : 'onSubmitContact'
    },
    
    transitionInComplete: function() {
    	// Check required fields
    	$("[required]").each(function(i, ele) {
    		var target = $(ele);
    		target.attr('placeholder', target.attr('placeholder')+'*');
    	});
    	
    	// Add phone number mask
    	$('input[type="tel"]').each(function (i, ele) {
    		//$(ele).mask('(999) 999-9999');
    	});
    	
    	// Add date mask
    	$('[data-type="date"]').each(function (i, ele) {
    		//$(ele).mask('99/99/9999');
    	});
    	
		// Load placeholders for older browsers
		$('input, textarea').placeholder();
	},
    
	onSubmitContact: function() {
		// Check for required fields
		$('.form input, .form textarea, .form select').each(function(i, ele) {		
			var target = $(ele);
			// Check for required attribute
			var attr = target.attr('required');
			if (typeof attr !== typeof undefined && attr !== false) {
				var val = target.val();
				if(val=="") {
				    target.addClass("invalidField");
					target.siblings(".label").addClass("invalidField");
					valid = false;
				}
			}
		});
		
		// Validate email through regex
		var email = $('.form input[name="email"]');
    	var valid = true;
    	var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
    	if (email.val() == '' || !re.test(email.val())) {
    		email.val("");
    		email.attr('placeholder', 'invalid email');
    		email.addClass("invalidField");
    		email.siblings(".label").addClass("invalidField");
    		valid = false;
    	}
    	
    	// Everything passed validation
    	if(valid) {
    		// Holder var
    		var data = new Array();
    		// Get all fields in .form    		
    		$(".form input, .form select, .form textarea").each(function(i, ele) {
    			// The target item
    			var target = $(ele);
    			
    			// Type
    			var type = target.attr('type');
    			    			
    			// Get name and value
    			var name = target.attr('name');
    			var value = target.val();
    			
    			// Push into data array
    			if(name!==undefined) {
    			    data.push(name+'='+value);
    			}
    			
    		});   		
    		// Create string
    		data = data.join('&');
    		
    		// Encode data as url string
    		data = encodeURI(data);
    		
    		// Send data
        	$.post('/library/ajax/submit_contact.cfm', data, function(result) {
        		result = jQuery.parseJSON(result);
    			if(result.success) {    				
    			    // Success
                    // Clear fields
                    $('.form input, .form select, .form textarea').each(function(i, ele) {
                        if($(this).attr('type')!="submit")
                            $(this).val("").removeClass("invalidField");
                            $(this).siblings(".label").removeClass("invalidField");
                    });
                    
                    this.showMessage('thank you', result.message);
    			} else {
    				// Fail
    			    this.showMessage('oops', result.message);
    			}
        	}.bind(this));
    	}
	},
	
	showMessage: function(title, message) {
        $('.thank-you h1', this.$el).html(title);
        $('.thank-you h4', this.$el).html(message);
        
        // Fade out form
        $(".form", this.$el).fadeOut(400, function() {
            $(".thank-you", this.$el).fadeIn();
        }.bind(this));
        
        // Show form again in 5 seconds
        setTimeout(function() {
            // Fade out form
            $(".thank-you", this.$el).fadeOut(400, function() {
                $(".form", this.$el).fadeIn();
            }.bind(this));
        }, 5000);
    }
  });
});

